import React, { useState, useEffect } from 'react';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { COLORS } from 'utils/GlobalVariables';

export const ScrollToTarget = ({ targetRef }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const targetTop = targetRef.current?.offsetTop ?? 0;
          setIsVisible(window.scrollY > targetTop);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [targetRef]);

  const goBackToTop = () => {
    if (targetRef.current) {
      // 125 is the offset with the full nav bar
      const top = targetRef.current.offsetTop - 125;
      window.scrollTo({
        top: top,
        behavior: 'smooth',
      });
    }
  };
  return (
    <React.Fragment>
      {isVisible && (
        <Fab
          color="primary"
          size="medium"
          onClick={goBackToTop}
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000,
            backgroundColor: COLORS.white,
            border: '2px solid' + COLORS.green,
            color: COLORS.green,
            '&:hover': {
              backgroundColor: COLORS.white,
              color: COLORS.yellow,
              border: '2px solid' + COLORS.yellow,
            },
          }}
        >
          <KeyboardArrowUpIcon sx={{ paddingLeft: '0px !important' }} />
        </Fab>
      )}
    </React.Fragment>
  );
};
